import styled from "styled-components";
import { GeneralReviewsSvg } from "../../components/Assets";

const Box = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 24px 20px;
  gap: 24px;
`;
export default function SpecialReviewNoData() {
  return (
    <Box style={{marginTop: 140}} >
      <img src={GeneralReviewsSvg}></img>
      <p className="flex flex-col gap-2">
        <b className="text-lg text-center">관심 리뷰가 없어요.</b>
        <span className="flex flex-col">
          <span className="text-center">
            검색 조건에 맞는 관심 리뷰가 없어요.
          </span>
        </span>
      </p>
    </Box>
  );
}
